export default "__VITE_ASSET__Dk6zIM6F__"